module.exports = __webpack_public_path__ + "img/mit.ad4c3ee1.png";